const pjson = require('../../package.json');

export const environment = {
    production: true,
    version: pjson.version,
    tenantId: 'default',
    server: {
        protocol: 'https',
        host: 'api.tuti.education',
        port: 443,
        apiPath: 'api/'
    },
    websocket: {
        host: 'api.tuti.education',
        port: 443
    },
    appTitle: "Tutì",
    configuration: <any>{},
    user: <any>{},
    swarmifyLoaded: false,
    websocketNotificationService: <any>Object,
    notificationService: <any>Object,
    userService: <any>Object,
    ImageAssets: <any>{},
    tt01DBVersion: 1,
    webDeviceUUID: "",
    features: {
        enableRooms: true,
        enableSubscription: true,
        enableRegistration: true
    },
    gtag: {
        enabled: true,
        gtmIframeID: "GTM-W92PTXB4",
        config1: "G-ET135FQK6S",
        config2: "G-LFEKDJFN51"
    },
    iuBenda: {
        enabled: true,
        script1: {
            text: `var _iub = _iub || []; _iub.csConfiguration = {"askConsentAtCookiePolicyUpdate":true,"cookiePolicyInOtherWindow":true,"floatingPreferencesButtonDisplay":"bottom-right","perPurposeConsent":true,"siteId":3557997,"whitelabel":false,"cookiePolicyId":29835548,"lang":"it","cookiePolicyUrl":"https://www.tuti.education/cookie-policy", "banner":{ "acceptButtonCaptionColor":"#FFFFFF","acceptButtonColor":"#0073CE","acceptButtonDisplay":true,"backgroundColor":"#FFFFFF","closeButtonRejects":true,"customizeButtonCaptionColor":"#4D4D4D","customizeButtonColor":"#DADADA","customizeButtonDisplay":true,"explicitWithdrawal":true,"listPurposes":true,"position":"float-top-center","rejectButtonCaptionColor":"#FFFFFF","rejectButtonColor":"#0073CE","rejectButtonDisplay":true,"showTitle":false,"textColor":"#000000","usesThirdParties":false }};`
        },
        script2: {
            src: `https://cs.iubenda.com/autoblocking/3557997.js`
        }
    }
};